import React from 'react'

import { AppRefreshContext, AppRefresh } from 'context/AppRefreshContext'

export default function useAppRefresh(): AppRefresh {
  return React.useContext(AppRefreshContext)
}
